/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputHistoryEventEditableData
 */
export interface OutputHistoryEventEditableData {
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEventEditableData
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEventEditableData
     */
    customTarget?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEventEditableData
     */
    customTargetType: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEventEditableData
     */
    eventTime?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEventEditableData
     */
    eventType?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputHistoryEventEditableData
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputHistoryEventEditableData
     */
    targetId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEventEditableData
     */
    targetStatus?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputHistoryEventEditableData
     */
    targetType: number;
    /**
     * 
     * @type {number}
     * @memberof OutputHistoryEventEditableData
     */
    teamId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEventEditableData
     */
    video?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputHistoryEventEditableData
     */
    zoneId?: number;
}

/**
 * Check if a given object implements the OutputHistoryEventEditableData interface.
 */
export function instanceOfOutputHistoryEventEditableData(value: object): boolean {
    if (!('customTargetType' in value)) return false;
    if (!('targetType' in value)) return false;
    return true;
}

export function OutputHistoryEventEditableDataFromJSON(json: any): OutputHistoryEventEditableData {
    return OutputHistoryEventEditableDataFromJSONTyped(json, false);
}

export function OutputHistoryEventEditableDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputHistoryEventEditableData {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'] == null ? undefined : json['comment'],
        'customTarget': json['customTarget'] == null ? undefined : json['customTarget'],
        'customTargetType': json['custom_target_type'],
        'eventTime': json['eventTime'] == null ? undefined : json['eventTime'],
        'eventType': json['eventType'] == null ? undefined : json['eventType'],
        'id': json['id'] == null ? undefined : json['id'],
        'targetId': json['targetId'] == null ? undefined : json['targetId'],
        'targetStatus': json['targetStatus'] == null ? undefined : json['targetStatus'],
        'targetType': json['target_type'],
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'video': json['video'] == null ? undefined : json['video'],
        'zoneId': json['zoneId'] == null ? undefined : json['zoneId'],
    };
}

export function OutputHistoryEventEditableDataToJSON(value?: OutputHistoryEventEditableData | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'comment': value['comment'],
        'customTarget': value['customTarget'],
        'custom_target_type': value['customTargetType'],
        'eventTime': value['eventTime'],
        'eventType': value['eventType'],
        'id': value['id'],
        'targetId': value['targetId'],
        'targetStatus': value['targetStatus'],
        'target_type': value['targetType'],
        'teamId': value['teamId'],
        'video': value['video'],
        'zoneId': value['zoneId'],
    };
}

